export default __webpack_public_path__ + "static/media/istanbul_heart_half.5a705e74.png";